// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clock': IconClock;
    }
}

/**
 * The icon component for the 'clock' icon
 */
export class IconClock extends IconSvg {
    public constructor() {
        super(clock16X16);
    }
}

registerIconSvg('icon-clock', IconClock);
export const iconClockTag = 'nimble-icon-clock';
